import LoyaltyProgramListPanel from './loyaltyProgramListPanel.container';

export default LoyaltyProgramListPanel;